jQuery(function($){
  
  $(document).ready(function(){
      // $('#tabs-nav li:first-child').addClass('active');
    $('.tab-content').hide();
 //   $('.tab-content:first').show();

    // Click function
    $('#tabs-nav li').click(function(){
      $('#tabs-nav li').removeClass('active');
      $(this).addClass('active');
      $('.tab-content').hide();

      var activeTab = $(this).find('a').attr('href');
      $(activeTab).fadeIn();
      return false;
    });
    
     var moretext = "More";
    var lesstext = "Less";
    $(".morelink").click(function(){
        if($(this).hasClass("less")) {
            $(this).removeClass("less");
            $(this).next('.more').slideUp();
           $(this).html(moretext);
        } else {
            $(this).addClass("less");
            $(this).next('.more').slideDown();
          $(this).html(lesstext);
        }
       
        return false;
    });
    
     var salePrice = $('.template-product .product__price.on-sale').text();
    $('.product__price.product__price--compare').append('<span class="sale">' + salePrice +'</span>');
    
    
    /*$('.variant__button-label').on('click',function(){
      if($('.add-to-cart').hasClass('disabled')){
      	$('.notice').append('Size Sold Out');
      }
      
    });*/
    
    $('#shopify-section-1599105562876 .flex-grid ').slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 3,
         responsive: [
          
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay:true,
              adaptiveHeight:true
            }
          }
         
        ]
      });
    $('.lc').click(function(e){
      e.preventDefault();
      $('#comments').slideToggle();
    });
    
    $("a[href^='#']:not(.tabBtn)").click(function (e) {
      e.preventDefault();
      elementClick = $(this).attr("href");
      if($(elementClick).length){
        destination = $(elementClick).offset().top - 70;
        $('body,html').animate({
          scrollTop: destination
        }, 1000);
      }
    });

   
    
    var prodImgHeight = $('.page-content--product .product-single__meta').height() + 130;
    var windowWidth = $(window).width();
    $(window).on('load resize',function(e){
      
      if(windowWidth <= 1049 ){
      	$('.sizeguide').css('height',prodImgHeight  );
      }
      
     
      
    });
    
    $('.add-to-cart').text('Buy now & Checkout');
    
   
    
    $('.variant-input-wrap[name="Size"]').prepend('<a class="sguide">Size guide</a>');
  
      $('.popular-slider').slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 5,
         responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              dots:true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2, 
              centerMode: true,
              centerPadding: '40px',
              dots:true
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '40px',
              dots:true
            }
          }
         
        ]
      });
    
    $('#ProductSection-related-products .grid--uniform').slick({
        infinite: true,
      	autoplay: true,
        slidesToShow: 3,
        slidesToScroll: 1,
         responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              centerMode:true,
              centerPadding: '60px',
            }
          },
           {
            breakpoint: 500,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode:true,
              centerPadding: '60px',
            }
          },
          
         
        ]
      });
    
       $('.product-recommendations .grid--uniform').slick({
        infinite: true,
      	autoplay: true,
        slidesToShow: 3,
        slidesToScroll: 1,
         responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              centerMode:true,
              centerPadding: '60px',
            }
          },
           {
            breakpoint: 500,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode:true,
              centerPadding: '60px',
            }
          },
          
         
        ]
      });
          
    
      
    
      
     /* $(' #insta-feed').slick({
            slidesToShow: 5,
            slidesToScroll: 5,
             responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  centerMode:true,
                  centerPadding: '60px',
           			infinite:true,
           			autoplay:true
                }
              },
               {
                breakpoint: 500,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  centerMode:true,
                  centerPadding: '60px',
           			infinite:true,
          			 autoplay:true
                }
              },


            ]
          });*/
      
   
    

    
    
      $('ul.tabs li').click(function(){
		var tab_id = $(this).attr('data-tab');

		$('ul.tabs li').removeClass('current');
		$('.tab-content').removeClass('current');

		$(this).addClass('current');
		$("#"+tab_id).addClass('current');
	 });
    
    $('.toggle').click(function(e) {
        e.preventDefault();

        var $this = $(this);

        if ($this.next().hasClass('show')) {
            $this.next().removeClass('show');
            $this.next().slideUp(350);
        } else {
            $this.parent().parent().find('li .inner').removeClass('show');
            $this.parent().parent().find('li .inner').slideUp(350);
            $this.next().toggleClass('show');
            $this.next().slideToggle(350);
        }
	});
           
    $('.collection-content .accordion li:nth-child(1) .inner').addClass('show');
    
    
//     $(document.body).on("click", "a.remove_item", function(e){
//     	var item_id = $(this).data("id");
      
// //         var params = {
// //           type: 'POST',
// //           url: '/cart/update.js',
// //           data: 'updates['+item_id+']=0',
// //           success:
// //         };
// 		console.log(theme.cart);
//       	console.log(theme.CartDrawer);
      
//       $.ajax({
//           type: 'POST',
//           url : '/cart/update.js', 
//           data: 'updates['+item_id+']=0', 
//           dataType: 'json',
//           success: function(response){
//           	console.log(response);
// //           	var cart
// //         	theme.CartDrawer.updateSuccess(cart);
//           	console.log("rebuild cart");
// //           	theme.cart.getCart().then(theme.CartDrawer.buildCart);
//           },
//       });
      
//     });
           
       var img_src = '';
        $(document).on( 'scroll', function(){
            if ($(window).scrollTop() > 10) {
                    $("img.to-be-lazyload").each(function(){
                        img_src = $(this).attr("data-src");
                        $(this).attr("src",img_src);
                });
            };   
        });
    
   });
});